<script>
import Layout from "../../layouts/main";
import Account from './account.vue';
import AdvancedSettings from './advanced-settings.vue';
import DccSettings from './dcc-settings.vue';
import ReconScopedAccess from './recon-scoped-access.vue';
import Api from './api.vue';
import Notifications from './notifications.vue';
import Profile from './profile.vue';
import Team from './team.vue';
import Webhook from './webhook.vue';
import { FETCH_MERCHANT_ENTITY_DETAILS } from "@/state/actions.type";

export default {
    components: {
        Layout,
        Profile,
        Team,
        Api,
        Webhook,
        AdvancedSettings,
        Account,
        Notifications,
        DccSettings,
        ReconScopedAccess
    },
    data() {
        return {
            activeTab: "Profile",
            tabs: ['Profile']
        }
    },
    computed: {
        isMasterMerchant() {
            return this.$store.state.auth.currentUser.is_master_merchant;
        },
        isOnboardingCompleted() {
            return this.$store.state.auth.currentUser.is_onboarding_completed;
        },
        userRoles() {
            return this.$store.getters["auth/getUserRolesList"];
        },
        entityDetails() {
            return this.$store.state.merchant.entityDetails;
        }
    },
    watch: {
        '$route.query.tab'() {
            if(this.$route.query.tab && this.tabs.includes(this.$route.query.tab)) {
                this.activeTab = this.$route.query.tab;
            }
        },
    },
    created() {
        if((this.userRoles.includes('admin') || this.userRoles.includes('sub-admin'))) {
             this.tabs.push('Account', 'Team', 'API', 'Webhooks', 'DCC Settings')
        }
        if(!this.isMasterMerchant && (this.userRoles.includes('admin') || this.userRoles.includes('sub-admin'))) {
            // add Notifications tab
            this.tabs.splice(3, 0, "Notifications");
            // add Advanced tab
            this.tabs.splice(6, 0, "Advanced");
        }

        if(this.$route.query.tab && this.tabs.includes(this.$route.query.tab)) {
            this.activeTab = this.$route.query.tab;
        }

        // "Recon Scoped Access" tab is only shown to Admins, and only once we know
        // (from the merchant entity details) that recon data access is enabled.
        if(this.userRoles.includes('admin')) {
            this.$store.dispatch(`merchant/${FETCH_MERCHANT_ENTITY_DETAILS}`).then(() => {
                if(this.entityDetails.recon_data_access_enabled) {
                    this.tabs.push('Recon Scoped Access');
                    if(this.$route.query.tab === 'Recon Scoped Access') {
                        this.activeTab = 'Recon Scoped Access';
                    }
                }
            });
        }
    },
    methods: {
        tabClicked(tab) {
            this.activeTab = tab;
            this.$router.push({name: 'General Settings', query: {tab: tab}});
        }
    }
}
</script>

<template>
    <Layout>
        <div class="menu-content">
            <div class="tab-content-section">
                <b-btn variant="primary" v-for="(tab, index) in tabs" :key="index" @click="tabClicked(tab)" class="tab-button" :class="{'tab-active': activeTab === tab, 'disable-side-bar': !isOnboardingCompleted && tab == 'Team'}">{{ tab }}</b-btn>
            </div>
        </div>
        <Profile v-if="activeTab === 'Profile'" />
        <account v-if="activeTab === 'Account'" />
        <Team v-else-if="activeTab === 'Team' && isOnboardingCompleted" />
        <notifications v-if="activeTab === 'Notifications'" />
        <Api v-else-if="activeTab === 'API'" />
        <Webhook v-else-if="activeTab === 'Webhooks'" />
        <advanced-settings v-else-if="activeTab === 'Advanced' && !isMasterMerchant" />
        <dcc-settings v-else-if="activeTab === 'DCC Settings'" />
        <recon-scoped-access v-else-if="activeTab === 'Recon Scoped Access'" />
    </Layout>
</template>

<style>

</style>